import React, {useContext, useEffect, useState} from "react"
import moment from "moment"

import ShelfApi from "~/utils/ShelfApi.js"
import Button from "~/components/Button"
import {ShoppingCartContext} from "../../context/ShoppingCartContext"
const icon_delete = require("~/icons/action_delete.svg")

const ListItemShoppingCart = ({
  id,
  product,
  user,
  added_at,
  quantity,
  index
}) => {
  const [itemQuantity, setItemQuantity] = useState(0)
  const {updateShoppingCart} = useContext(ShoppingCartContext)
  const [error, setError] = useState("")

  useEffect(() => {
    setItemQuantity(quantity)
  }, [quantity])

  const updateQuantity = (shoppingCartItemId, quantity) => {
    ShelfApi.put(`/product_in_carts/${shoppingCartItemId}/`, {quantity}).catch(
      e => {
        setError("Fehler beim aktualisieren des Warenkorb.")
      }
    )
    setItemQuantity(quantity)
  }

  const deletePosition = shoppingCartItemId => {
    if (
      window.confirm("Wollen Sie diese Position aus dem Warenkorb entfernen?")
    ) {
      ShelfApi.delete(`/product_in_carts/${shoppingCartItemId}/`)
        .then(res => {
          updateShoppingCart()
        })
        .catch(e => {
          setError("Artikel konnte nicht entfernt werden.")
        })
    }
  }

  return (
    <div className="sh-list-item">
      <div className="content">
        <div className="box-name">
          <div className="article-position primary">Pos. {index + 1}</div>
          <div className="article-description">
            <div className="primary">{product.name}</div>
            <div className="secondary simplified">
              <span>{`Hinzugefügt von ${user.email} am ${moment(
                added_at
              ).format("DD.MM.YYYY")}`}</span>
            </div>
          </div>
        </div>
        <div className="error">{error}</div>
      </div>

      <Button
        onClick={() => {
          if (itemQuantity > 1) {
            updateQuantity(id, itemQuantity - 1)
          }
        }}
        label="–"
        primary
      />
      <input
        value={itemQuantity}
        type="number"
        min="1"
        className="shopping-cart-quantity"
        onChange={e => updateQuantity(id, e.target.value)}
      />
      <Button
        onClick={() => {
          updateQuantity(id, itemQuantity + 1)
        }}
        label=" + "
        primary
      />
      <Button
        onClick={() => {
          deletePosition(id)
        }}
        icon={icon_delete}
        label=""
      />
    </div>
  )
}

export default ListItemShoppingCart



// WEBPACK FOOTER //
// ./src/components/list_items/ListItemShoppingCart.js